<template>
  <v-container>
    <div class="back-nav">
      <v-btn class="back-button" text :to="{ name: 'customers' }" exact>
        <v-icon class="back-arrow-icon" left>$downarrow</v-icon>
        My customers
      </v-btn>
    </div>
    <div class="header">
      <h2 class="d-sm-inline-block">Customer: {{ vm.customerName }}</h2>
    </div>

    <v-skeleton-loader
      v-if="loading"
      type="table-row-divider"
    ></v-skeleton-loader>
    <v-tabs v-else hide-slider v-model="activeTab" class="secondary-nav">
      <v-tab v-for="tab in tabs" :key="`${tab.name}-tab`" :to="`#${tab.route}`"
        >{{ tab.name }}
      </v-tab>
    </v-tabs>

    <v-skeleton-loader v-if="loading" type="table"></v-skeleton-loader>
    <v-tabs-items v-else :value="activeTab">
      <v-tab-item
        v-for="tab in tabs"
        :key="`${tab.name}-tabitem`"
        :value="tab.route"
      >
        <foldable-card
          non-foldable
          :title="tab.title"
          :description="tab.desc"
          style="border-top-width: 8px"
        >
          <component
            :is="tab.component"
            :customer-id="customerId"
            v-bind="tab.data"
          />
        </foldable-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import {
  customerDetailsAPI,
  checklistItemConfigurationAPI
} from "@/services/api";
import { get } from "@/services/request";
import EvdHistorical from "@/components/EvdHistorical";
import CustomerTodos from "./CustomerTodos";
import FoldableCard from "@/components/FoldableCard";
import ProofOfEnrollment from "@/views/customers/ProofOfEnrollment.vue";

const todoTab = {
  name: "To-Dos",
  title: "To-Dos",
  route: "todos",
  component: CustomerTodos
};

const proofOfEnrollmentTab = {
  name: "Proof of Enrollment",
  title: "Proof of Enrollment",
  route: "proofOfEnrollment",
  component: ProofOfEnrollment
};

export default {
  components: { CustomerTodos, EvdHistorical, FoldableCard },
  props: ["customerId"],
  name: "customerDetail",
  data: () => ({
    vm: {},
    controls: {
      editMode: false
    },
    loading: true,
    activeTab: null,
    tabs: [todoTab]
  }),
  created: function() {
    let p1 = this.loadCustomer();
    let p2 = this.loadConfig();

    Promise.all([p1, p2]).then(() => {
      this.loading = false;
    });
  },
  methods: {
    loadCustomer() {
      return get(
        customerDetailsAPI.getUrl({ customerId: this.customerId })
      ).then(response => {
        if (response && response.data) {
          this.vm = response.data;
          if (this.vm.enrollmentCompleteDate != null) {
            this.tabs.splice(1, 0, proofOfEnrollmentTab);
          }
        }
      });
    },
    loadConfig() {
      return get(checklistItemConfigurationAPI, {
        type: "EVD_HISTORICAL",
        clientId: this.customerId
      }).then(response => {
        if (response && response.data) {
          this.tabs.push(
            ...response.data.map(({ evdId, evdName, id: configId }) => ({
              name: evdName,
              title: evdName,
              route: `${configId}`,
              component: EvdHistorical,
              data: {
                configId,
                evdId
              }
            }))
          );
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
h2
  font-size: 35px
  line-height: 44px
  color: $darker-grey

.back-arrow-icon
  transform: rotate(90deg)
  max-width: 12px
  margin-top: 1px
  margin-right: 7px

.v-btn
  font-weight: bold
  letter-spacing: unset
  text-indent: unset
  font-size: 1rem

.back-button.v-btn.v-btn--text
  & ::v-deep > .v-btn__content
    color: $subtitle
    font-size: 16px
    line-height: 20px
    text-align: center
    font-weight: 600
    text-indent: unset
</style>
